import React from 'react';
import { useTranslation } from 'react-i18next';
import './styles.css';

const ProfileVisibilityContent = ({ selectedOption, onVisibilityChange }) => {
  const { t } = useTranslation('settings');

  const options = [
    {
      id: 'everyone',
      label: t('pages.privacy.profileVisibility.options.public'),
      description: t('pages.privacy.profileVisibility.options.publicDescription')
    },
    {
      id: 'followers',
      label: t('pages.privacy.profileVisibility.options.friends'),
      description: t('pages.privacy.profileVisibility.options.friendsDescription')
    },
    {
      id: 'nobody',
      label: t('pages.privacy.profileVisibility.options.private'),
      description: t('pages.privacy.profileVisibility.options.privateDescription')
    }
  ];

  const handleOptionChange = (optionId) => {
    onVisibilityChange(optionId);
  };

  return (
    <div className="visibility-content">
      <h2 className="visibility-title">{t('pages.privacy.profileVisibility.title')}</h2>
      <p className="preferences-section-description">
        {t('pages.privacy.profileVisibility.description')}
      </p>
      
      <div className="preferences-options-list">
        {options.map((option) => (
          <label 
            key={option.id} 
            className={`preference-radio-option ${selectedOption === option.id ? 'selected' : ''}`}
          >
            <div className="preference-radio-content">
              <div className="preference-radio-label">{option.label}</div>
              <div className="preference-radio-description">{option.description}</div>
            </div>
            <input
              type="radio"
              name="profileVisibility"
              value={option.id}
              checked={selectedOption === option.id}
              onChange={() => handleOptionChange(option.id)}
              className="preference-radio-input"
            />
            <span className="preference-radio-custom"></span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default ProfileVisibilityContent; 